$(function () {
  $(document).on('click', '.js-paginate-link a', function () {
    $(this).addClass('avoid-click').append("<i class='fas fa-spinner fa-spin mx-2'></i>");
  });
});
